import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Toast, ToastService } from '../../services/toast-service';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast-component.html',
  styleUrl: './toast-component.scss',
})
export class ToastComponent {
  public toastService = inject(ToastService);

  handleAction(toast: Toast) {
    if (toast.actionCallback) {
      toast.actionCallback();
    }
    this.toastService.remove(toast.id);
  }
}